import { TabManagerApproveValues } from '@pages/approval-manager-page/config/ui-constants';
import { SegmentTab } from '@shared/ui/segment-tabs/types';

export const tabs = ({
    orderCount,
    requestCount,
}: {
    orderCount: number | undefined;
    requestCount: number | undefined;
}): SegmentTab[] => {
    const orderTab: SegmentTab = {
        title: 'Сделки',
        value: TabManagerApproveValues.Orders,
    };

    const requestTab: SegmentTab = {
        title: 'Запросы',
        value: TabManagerApproveValues.Requests,
    };

    if (orderCount) {
        orderTab.badge = {
            text: String(orderCount),
        };
    }

    if (requestCount) {
        requestTab.badge = {
            text: String(requestCount),
        };
    }

    return [orderTab, requestTab];
};
